import Swal from "sweetalert2"; // Correct import for sweetalert2

export const updateAuditData = async (recordId, updateData) => {
  console.log("updateAuditData called with:", { recordId, updateData });

  if (!recordId) {
    console.error("No recordId provided to updateAuditData");
    Swal.fire({
      title: "Update Failed",
      text: "No record ID provided for update.",
      icon: "error",
      confirmButtonText: "OK",
    });
    return false;
  }

  const conn_name = "crmwidgetconnection";
  const apiUrl = `https://www.zohoapis.com/creator/v2.1/data/sst1source/source-erp/report/All_internal_audits/${recordId}`;

  // Make sure we're using the correct field names according to Zoho Creator API
  const formattedData = {};

  // Basic fields
  if (updateData.Title !== undefined) formattedData.Title = updateData.Title;
  if (updateData.Record_Stage !== undefined)
    formattedData.Record_Stage = updateData.Record_Stage;
  if (updateData.Status !== undefined) formattedData.Status = updateData.Status;

  // Fix for Quality Owner - The API expects just the ID, not the full object
  if (updateData.Quality_owner1 !== undefined) {
    // Just send the ID as a string, not as an object
    formattedData.Quality_owner1 = updateData.Quality_owner1.toString();
  }

  if (updateData.Quality_Origin !== undefined)
    formattedData.Quality_Origin = updateData.Quality_Origin;

  // Description
  if (updateData.Description !== undefined)
    formattedData.Description = updateData.Description;

  // Map component field names to API field names
  // Use snake_case for API fields
  if (updateData.scopeAccurate !== undefined)
    formattedData.scopeAccurate = updateData.scopeAccurate;
  if (updateData.activitiesCovered !== undefined)
    formattedData.activitiesCovered = updateData.activitiesCovered;

  // Clause 4.4: Process review
  if (updateData.qmsAccurate !== undefined)
    formattedData.qmsAccurate = updateData.qmsAccurate;
  if (updateData.inputsOutputs !== undefined)
    formattedData.inputsOutputs = updateData.inputsOutputs;
  if (updateData.processResources !== undefined)
    formattedData.processResources = updateData.processResources;
  if (updateData.peopleAssigned !== undefined)
    formattedData.peopleAssigned = updateData.peopleAssigned;
  if (updateData.correctiveAction !== undefined)
    formattedData.correctiveAction = updateData.correctiveAction;
  if (updateData.processImprovement !== undefined)
    formattedData.processImprovement = updateData.processImprovement;

  // Clause 5.3: Roles and responsibilities
  if (updateData.rolesResponsibilities !== undefined)
    formattedData.rolesResponsibilities = updateData.rolesResponsibilities;

  // Clause 8.1: Process review
  if (updateData.processesPlanned !== undefined)
    formattedData.processesPlanned = updateData.processesPlanned;
  if (updateData.outsourcedProcesses !== undefined)
    formattedData.outsourcedProcesses = updateData.outsourcedProcesses;
  if (updateData.inspectionCriteria !== undefined)
    formattedData.inspectionCriteria = updateData.inspectionCriteria;
  if (updateData.supportProcedures !== undefined)
    formattedData.supportProcedures = updateData.supportProcedures;

  // Clause 8.2.1: Quoting
  if (updateData.quotingProcedure !== undefined)
    formattedData.quotingProcedure = updateData.quotingProcedure;
  if (updateData.customerQuestions !== undefined)
    formattedData.customerQuestions = updateData.customerQuestions;

  // Clause 8.2.2: Customer requirements
  if (updateData.customerRequirementsCaptured !== undefined)
    formattedData.customerRequirementsCaptured =
      updateData.customerRequirementsCaptured;
  if (updateData.requirementsReviewed !== undefined)
    formattedData.requirementsReviewed = updateData.requirementsReviewed;

  // Clause 8.2.3: Customer requirements
  if (updateData.applicableRequirements !== undefined)
    formattedData.applicableRequirements = updateData.applicableRequirements;
  if (updateData.quoteReviewed !== undefined)
    formattedData.quoteReviewed = updateData.quoteReviewed;

  // Clause 8.2.4: Order entry
  if (updateData.changeAgreed !== undefined)
    formattedData.changeAgreed = updateData.changeAgreed;
  if (updateData.changesDocumented !== undefined)
    formattedData.changesDocumented = updateData.changesDocumented;

  // Clause 8.3: Customer Design
  if (updateData.acceptingProcedure !== undefined)
    formattedData.acceptingProcedure = updateData.acceptingProcedure;
  if (updateData.designRecords !== undefined)
    formattedData.designRecords = updateData.designRecords;
  if (updateData.designReview !== undefined)
    formattedData.designReview = updateData.designReview;
  if (updateData.designChanges !== undefined)
    formattedData.designChanges = updateData.designChanges;
  if (updateData.designApproval !== undefined)
    formattedData.designApproval = updateData.designApproval;
  if (updateData.nonconformityPrevention !== undefined)
    formattedData.nonconformityPrevention = updateData.nonconformityPrevention;

  // Clause 8.4: Purchasing
  if (updateData.supplierControls !== undefined)
    formattedData.supplierControls = updateData.supplierControls;
  if (updateData.supplierEvaluations !== undefined)
    formattedData.supplierEvaluations = updateData.supplierEvaluations;
  if (updateData.evaluationRecords !== undefined)
    formattedData.evaluationRecords = updateData.evaluationRecords;
  if (updateData.receivingInspection !== undefined)
    formattedData.receivingInspection = updateData.receivingInspection;
  if (updateData.poReviews !== undefined)
    formattedData.poReviews = updateData.poReviews;
  if (updateData.poInformation !== undefined)
    formattedData.poInformation = updateData.poInformation;

  // Clause 8.5: Production
  if (updateData.productInfo !== undefined)
    formattedData.productInfo = updateData.productInfo;
  if (updateData.inspectionDevices !== undefined)
    formattedData.inspectionDevices = updateData.inspectionDevices;
  if (updateData.inProcessInspections !== undefined)
    formattedData.inProcessInspections = updateData.inProcessInspections;
  if (updateData.facilitiesEquipment !== undefined)
    formattedData.facilitiesEquipment = updateData.facilitiesEquipment;
  if (updateData.operatorTraining !== undefined)
    formattedData.operatorTraining = updateData.operatorTraining;
  if (updateData.productIdentification !== undefined)
    formattedData.productIdentification = updateData.productIdentification;
  if (updateData.inspectionStatus !== undefined)
    formattedData.inspectionStatus = updateData.inspectionStatus;
  if (updateData.propertyOwner !== undefined)
    formattedData.propertyOwner = updateData.propertyOwner;
  if (updateData.shelfLifeItems !== undefined)
    formattedData.shelfLifeItems = updateData.shelfLifeItems;
  if (updateData.productHandling !== undefined)
    formattedData.productHandling = updateData.productHandling;
  if (updateData.productStorage !== undefined)
    formattedData.productStorage = updateData.productStorage;
  if (updateData.postDeliveryWork !== undefined)
    formattedData.postDeliveryWork = updateData.postDeliveryWork;
  if (updateData.customerComplaints !== undefined)
    formattedData.customerComplaints = updateData.customerComplaints;
  if (updateData.processChanges !== undefined)
    formattedData.processChanges = updateData.processChanges;

  // Clause 8.6: Final inspection
  if (updateData.finalinspectionsORtestsConducted !== undefined)
    formattedData.finalinspectionsORtestsConducted =
      updateData.finalinspectionsORtestsConducted;
  if (updateData.finalinspectionrecordskept !== undefined)
    formattedData.finalinspectionrecordskept =
      updateData.finalinspectionrecordskept;
  if (updateData.finalinspectionrecordsinclude !== undefined)
    formattedData.finalinspectionrecordsinclude =
      updateData.finalinspectionrecordsinclude;

  // Clause 8.7: Non-conforming product
  if (updateData.nonconformingproductsproperlyidentified !== undefined)
    formattedData.nonconformingproductsproperlyidentified =
      updateData.nonconformingproductsproperlyidentified;
  if (updateData.doesthecompanynotifycustomers !== undefined)
    formattedData.doesthecompanynotifycustomers =
      updateData.doesthecompanynotifycustomers;
  if (updateData.nonconformingproductdealtwith !== undefined)
    formattedData.nonconformingproductdealtwith =
      updateData.nonconformingproductdealtwith;
  if (updateData.nonconformingproductsegregatedor !== undefined)
    formattedData.nonconformingproductsegregatedor =
      updateData.nonconformingproductsegregatedor;
  if (updateData.customernotifiedwhenapplicable !== undefined)
    formattedData.customernotifiedwhenapplicable =
      updateData.customernotifiedwhenapplicable;
  if (updateData.productisreworkedorrepaired !== undefined)
    formattedData.productisreworkedorrepaired =
      updateData.productisreworkedorrepaired;
  if (updateData.recordsofthenonconformities !== undefined)
    formattedData.recordsofthenonconformities =
      updateData.recordsofthenonconformities;
  if (updateData.customerapprovalsorwaivers !== undefined)
    formattedData.customerapprovalsorwaivers =
      updateData.customerapprovalsorwaivers;

  // Clause 9.1: Business performance
  if (updateData.methodsunderwaytomonitor !== undefined)
    formattedData.methodsunderwaytomonitor =
      updateData.methodsunderwaytomonitor;
  if (updateData.companymeasuringproduct !== undefined)
    formattedData.companymeasuringproduct = updateData.companymeasuringproduct;
  if (updateData.companykpi !== undefined)
    formattedData.companykpi = updateData.companykpi;
  if (updateData.suppliersbeingmeasured !== undefined)
    formattedData.suppliersbeingmeasured = updateData.suppliersbeingmeasured;

  // Auditor Approved
  if (updateData.auditorApproved !== undefined)
    formattedData.auditorApproved = updateData.auditorApproved;

  // Log the formatted data being sent to the API
  console.log("Sending formatted data to API:", formattedData);

  const payload = {
    parameters: {
      data: formattedData,
    },
    method: "PATCH",
    url: apiUrl,
    param_type: 2,
  };

  try {
    console.log("Sending request to ZOHO.CRM.CONNECTION.invoke");
    const response = await ZOHO.CRM.CONNECTION.invoke(conn_name, payload);
    console.log("Update Response:", response);

    // Check for specific error about invalid Quality_owner1 format
    if (
      response &&
      response.details &&
      response.details.statusMessage &&
      response.details.statusMessage.error &&
      response.details.statusMessage.error[0]?.includes("Invalid column value")
    ) {
      console.error(
        "Quality Owner format error:",
        response.details.statusMessage.error[0]
      );

      Swal.fire({
        title: "Update Failed",
        text: "There was an issue with the Quality Owner field. Please try selecting a different owner or contact support.",
        icon: "error",
        confirmButtonText: "OK",
      });
      return false;
    }

    // Fix: Updated success condition to handle code 3000 which means "Data Updated Successfully"
    if (
      response &&
      response.code === "SUCCESS" &&
      (response.details?.statusMessage?.code === 3001 || // Previous success condition
        response.details?.statusMessage?.code === 3000 || // New success condition
        (response.details?.status === "true" &&
          !response.details?.statusMessage?.error)) // Additional fallback
    ) {
      // Success response detected
      console.log(
        "Update successful with code:",
        response.details?.statusMessage?.code
      );

      Swal.fire({
        title: "Audit Updated",
        text: "Changes saved successfully.",
        icon: "success",
        confirmButtonText: "OK",
      });
      return true; // Indicate success
    } else {
      // Enhanced error handling
      let errorMsg;

      if (
        response?.details?.statusMessage?.error &&
        Array.isArray(response.details.statusMessage.error) &&
        response.details.statusMessage.error.length > 0
      ) {
        errorMsg = response.details.statusMessage.error.join("; ");
      } else if (
        response?.details?.statusMessage?.message &&
        response.details.statusMessage.message !== "Data Updated Successfully"
      ) {
        errorMsg = response.details.statusMessage.message;
      } else if (
        response?.details?.errors &&
        response.details.errors.length > 0
      ) {
        errorMsg = response.details.errors.map((err) => err.message).join("; ");
      } else if (response.code !== "SUCCESS") {
        errorMsg = response?.message || "Unknown error occurred.";
      } else {
        // If we got here but response.code is SUCCESS, treat it as success
        console.log(
          "Response has code SUCCESS but didn't match other conditions - treating as success"
        );
        Swal.fire({
          title: "Audit Updated",
          text: "Changes saved successfully.",
          icon: "success",
          confirmButtonText: "OK",
        });
        return true;
      }

      console.error("API error response:", errorMsg);

      Swal.fire({
        title: "Update Failed",
        text: errorMsg || "Update failed. Please try again.",
        icon: "error",
        confirmButtonText: "OK",
      });
      return false; // Indicate failure
    }
  } catch (err) {
    console.error("Update error:", err);

    Swal.fire({
      title: "Error",
      text: `An error occurred while updating the record: ${
        err.message || "Unknown error"
      }`,
      icon: "error",
      confirmButtonText: "OK",
    });
    return false; // Indicate failure
  }
};
